import { UserType } from '@llx/common';

import { MeetingFieldsFragment } from '@/@generated/codegen/API';

export default function shouldActivateChatFeature(
  meeting: MeetingFieldsFragment,
  userType: UserType
) {
  if (!meeting?.streamUrl) return false;
  if (userType === UserType.ADMIN || userType === UserType.GUEST) return true;
  return false;
}
